import { render, staticRenderFns } from "./config.vue?vue&type=template&id=01cb5ba8&scoped=true"
import script from "./config.vue?vue&type=script&lang=ts&setup=true"
export * from "./config.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./config.vue?vue&type=style&index=0&id=01cb5ba8&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cb5ba8",
  null
  
)

export default component.exports